import { Chip, ChipPropsColorOverrides } from '@mui/material';
import MuiAvatar from 'components/MuiExtras/MuiAvatar';
import * as React from 'react';

export type AutoCompleteChipColors =
    | "default"
    | "info"

interface IProps {
    item: AutoCompleteDataModel;
    className?: string;
    onResolveAvatar?: (item: AutoCompleteDataModel) => JSX.Element;
    onDelete?: (item: AutoCompleteDataModel) => void;
    onClick?: (item: AutoCompleteDataModel) => void;
    color?: AutoCompleteChipColors;
}

export const RenderAutoCompleteChip: React.FC<IProps> = (props) => {
    const { className, color, item, onResolveAvatar } = props;

    const avatar = onResolveAvatar
        ? onResolveAvatar(item)
        : item.thumbnailUrl != null
            ? <MuiAvatar size="small" src={item.thumbnailUrl} />
            : null;

    return (
        <Chip
            key={item.key || item.label}
            tabIndex={-1}
            label={item.label}
            className={className}
            color={color}
            size="small"
            avatar={avatar}
            onDelete={(item.key != "[]" && props.onDelete && item.fixed !== true) ? () => props.onDelete(item) : null}
            onClick={(item.key != "[]" && props.onClick) ? () => props.onClick(item) : null}
        />
    );
}

RenderAutoCompleteChip.defaultProps = {
    color: "default"
}